import { useState } from "react";
import Seo from "@/components/Seo";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { BookShowcase } from "@/components/BookShowcase";
import { Countdown } from "@/components/Countdown";
import { Leseprobe } from "@/components/Leseprobe";
import { CheckoutDrawer } from "@/components/CheckoutDrawer";
import { Manifesto } from "@/components/Manifesto";
import { AuthorSection } from "@/components/AuthorSection";
import { Testimonials } from "@/components/Testimonials";
import { TrustStrip } from "@/components/TrustStrip";
import { FaqSection } from "@/components/FaqSection";
import { Footer } from "@/components/Footer";

export default function Landing() {
  const [selectedBook, setSelectedBook] = useState(null);

  return (
    <div id="top" className="bg-void text-white min-h-screen">
      <Seo
        title="SCHATTENPSYCHE · Ein Profiler-Handbuch für den Alltag"
        siteName="SCHATTENPSYCHE"
        description="Das Profiler-Handbuch für den Alltag, Band 1 der Schattenpsyche-Trilogie. Lerne, Gesichter zu lesen, Körpersprache zu entschlüsseln und Signale zu erkennen, die andere übersehen. Von @schatten_psyche_."
        image="/logo.png"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Book",
          name: "Schattenpsyche · Ein Profiler-Handbuch für den Alltag",
          inLanguage: "de",
          bookFormat: "https://schema.org/Paperback",
          author: { "@type": "Person", name: "Schattenpsyche" },
        }}
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <BookShowcase onBuy={setSelectedBook} />
        <Countdown />
        <Leseprobe />
        <TrustStrip />
        <Manifesto />
        <AuthorSection />
        <Testimonials />
        <FaqSection />
      </main>
      <Footer />
      <CheckoutDrawer
        book={selectedBook}
        open={!!selectedBook}
        onClose={() => setSelectedBook(null)}
      />
    </div>
  );
}
